
/**
 * Service to work with the new scenario item format.
 * Format:
 * {
 *   "type": "vocabulary",
 *   "translations": { "en-US": "...", "uk-UA": "..." },
 *   "word_map": [ { "en-US": "...", "uk-UA": "..." } ]
 * }
 */

export const getTranslation = (item, langCode) => {
    return item?.translations?.[langCode] || "";
};

export const getWords = (item, langCode) => {
    if (!item?.word_map) return [];
    return item.word_map
        .map(m => m[langCode])
        .filter(Boolean);
};

/**
 * Extracts private based on the role (study/base).
 * @param {Object} item - The scenario item.
 * @param {string} role - 'study' or 'base'.
 * @param {Object} context - The state machine context containing studyLang and baseLang.
 * @returns {Object} { title, lang, words }
 */
export const getDataByRole = (item, role, context) => {
    const langCode = role === 'study' ? context.studyLang : context.baseLang;
    
    return {
        title: getTranslation(item, langCode),
        lang: langCode,
        words: getWords(item, langCode)
    };
};
